module.exports = __webpack_public_path__ + "static/assets/336207d357cd7c598c16c2ed204b9157.svg";